import React, { useEffect, useState } from 'react';

import styles from './AppTakeUp.module.scss';
export default function AppTakeUp() {
  //  if u want to scroll up when pagereloaded
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);
  const [isVisible, setIsVisible] = useState(false);

  const handelClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  const handleScroll = () => {
    const position = window.scrollY;

    if (position > 200) {
      setIsVisible(!isVisible);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    isVisible && (
      <div className={styles.AppTakeUp} onClick={handelClick}>
        <Take_Up />
        <p>Take me up!</p>
      </div>
    )
  );
}

function Take_Up() {
  return (
    <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.5" y="1.5" width="44" height="44" rx="22" fill="black" />
      <g filter="url(#filter0_d_365_18793)">
        <rect x="2.5" y="1.5" width="44" height="44" rx="22" fill="white" />
        <path
          d="M24.4993 29.3332V17.6665M24.4993 17.6665L18.666 23.4998M24.4993 17.6665L30.3327 23.4998"
          stroke="black"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="2.5" y="1.5" width="44" height="44" rx="22" stroke="black" />
      </g>
      <defs>
        <filter
          id="filter0_d_365_18793"
          x="0"
          y="0"
          width="49"
          height="49"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_365_18793" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_365_18793"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
